import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDropzone } from 'react-dropzone'

import { MAX_UPLOADED_IMAGE_SIZE } from 'constants/upload'

import ImageNotFill from 'assets/icon/image-not-fill.svg'

const DropZoneAsThumb = ({ onChange, onError }) => {
  const { getRootProps, getInputProps, isDragActive, fileRejections } = useDropzone({
    maxSize: MAX_UPLOADED_IMAGE_SIZE,
    multiple: false,
    accept: {
      'image/*': ['.webp', '.jpeg', '.png', '.gif', '.svg'],
    },
    onDrop: (acceptedFiles) => {
      if (acceptedFiles[0]) {
        onChange(acceptedFiles[0])
      }
    },
  })

  useEffect(() => {
    if (fileRejections.length) {
      onError(fileRejections)
    }
  }, [fileRejections])

  return (
    <div
      className={`group relative bg-white flex justify-center items-center w-full aspect-[1/.75] border ${isDragActive ? '!border-solid' : '!border-dashed'} !border-[#F79009] rounded-4 cursor-pointer`}
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      <img src={ImageNotFill} alt="image-thumb" className="max-h-full object-contain" />
    </div>
  )
}
DropZoneAsThumb.propTypes = {
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
}
export default React.memo(DropZoneAsThumb)
